export const assetKeys = {
  all: ["assets"] as const,
  project: (projectId: string) => [...assetKeys.all, projectId] as const,
};
